import React, {Component} from 'react';
import WebNews from "../webNews/webNews";
import {Scrollbars} from "react-custom-scrollbars";
import {HistoryList} from "../../../../../editor/staticButton/history/history";
import {uuid} from "../../../../../../utils";
import {checkWordReplace} from "../tool/htmlFormat";

/**
 * creat by tianruojun
 * @description 安全中心微信素材预览模块
 * @class Material
 * @extends {WebNews}
 */
export default class Material extends WebNews {
    constructor(props) {
        super(props);
        this.state.storyIndex = 0;
    }

    componentWillMount() {
    }

    componentDidMount() {
    }
    /**
     * 给稿件数据打敏感词标记
     */
    setCheckWord = ({stuffList=[]}) => {
        const {checkAllWord} = this.props;
        let {storyIndex} = this.state;
        let data = {
            summary: "",
            title: "",
            content: "",
            titlePic: "",
        };
        if(stuffList?.[storyIndex] ) {
            data.summary = stuffList?.[storyIndex]?.summary;
            data.title = stuffList?.[storyIndex]?.title;
            data.content = stuffList?.[storyIndex]?.content;
            if(checkAllWord?.length) {
                checkAllWord.forEach(item=>{
                    let itemWord = item.word;//错误词
                    let currWord;
                    let itemCorrectWord = item.correctWord;//正确词
                    if (item.category === "SENSITIVE") {
                        currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                    } else {
                        currWord = '“' + itemWord + '”建议删除';
                    }
                    let replaceHtml = '<span class="itemWord word" check="'+currWord+'">'+itemWord+'</span>';
                    data.content = checkWordReplace(data.content,item?.word,replaceHtml);
                    data.title = checkWordReplace(data.title,item?.word,replaceHtml);
                    data.summary = checkWordReplace(data.summary,item?.word,replaceHtml);
                })
            }
        }
        return data
    };
    // 内容部分
    renderContent = () => {
        const height = window.innerHeight - 24 - 20;
        const width = window.innerWidth - 680;// 左右各留340距离
        const publicStyle = {
            fontWeight: '400',
            marginBottom: '24px'
        };
        let {title,summary,content} = this.getData();
        return (
            <div className={'details_content'} style={{height: height,width}}>
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        {/*标题*/}
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: '22px',
                                textAlign: 'left',
                                fontWeight: 700,
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*摘要*/}
                        <div style={{
                            fontSize: '14px',
                            color: 'rgba(0, 0, 0, 0.45)',
                            ...publicStyle,
                        }}
                             dangerouslySetInnerHTML={{__html: summary}}
                        >
                        </div>
                        {/*正文*/}
                        <div
                            style={{
                                fontSize: '14px',
                                color: 'rgba(0, 0, 0, 0.65)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: content}}
                        >
                        </div>
                    </div>
                    <style>
                        {`
                        font.word {
                        color: #fff;
                        background-color: red;
                        cursor: pointer;
                        }
                    `}
                    </style>
                </Scrollbars>

            </div>
        )
    };
    getStoryList = () => {
        let {dataSource,storyIndex} = this.state;
        dataSource.stuffList[storyIndex].historyItemClassName = "historyItemCheck";
        return dataSource.stuffList
    };
    // 列表部分
    renderLeft = () => {
        let storyList = this.getStoryList();
        if(!storyList?.length) {
            return ""
        }
        return (
            <div style={{position: 'fixed', left: 203, top: -17, background: '#fff',}}>
                <HistoryList
                    isContentDetail={'contentSecurityCenter'}
                    itemComponentClick={(editor, item, storyIndex) => {
                        this.setState({storyIndex})
                    }}
                    itemComponentStyle={{height:64}}
                    itemComponent={HistoryItem}
                    title={<span style={{fontSize:16}}>文章列表</span>}
                    visible={true}
                    data={storyList}
                />
            </div>
        )
    };
}

class HistoryItem extends Component {
    static defaultProps = {
        style: {},
        className: "historyItem",
        onClick: () => {
        }
    };

    render() {
        let {item} = this.props;
        return <div onClick={() => {
            this.props.onClick()
        }} className={this.props.className} style={{
            borderLeft: '3px solid #24B481',
            borderLeftWidth: 3,
            borderLeftStyle: 'solid',
            borderRadius: 3,
            padding: 10,
            borderColor: this.props.color, ...this.props.style
        }}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"100%"}>
                <tbody>
                <tr>
                    <td valign={"middle"}>
                        <div
                            title={item.title}
                            className={"plan-pointer showTwoText"}
                             style={{
                                 marginRight: 20,
                                 paddingLeft: 5,
                                 width: 240,
                                 overflow:'hidden',
                                 textOverflow:'ellipsis',
                                 display:'-webkit-box',
                                 WebkitBoxOrient:'vertical',
                                 WebkitLineClamp:'1',
                             }}
                        >
                            {item.title ? item.title : "错误数据"}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <style>{`
                .checkPage .historyItem:hover{
                    background: #ccd9eb !important;
                    border-left-color: #ccd9eb !important;
                }
                .checkPage .historyItemCheck{
                    border-left-color: rgb(18, 100, 201) !important;
                    background: #ebf1f9 !important
                }
                .checkPage .historyItem{
                    border-left-color: #f5f8fc !important;
                    background: #f5f8fc
                }
            `}</style>
        </div>
    }
}